import { put, takeEvery } from 'redux-saga/effects'
import call from '../call'
import { AUTHMANAGE } from '../actionTypes'
import { message } from 'antd'

import {
  getRoleList as getRoleListService,
  getRoleInfo as getRoleInfoService,
  addRole as addRoleService,
  updateRole as updateRoleService,
  updateRoleResourceBind as updateRoleResourceBindService,
  getEntityList as getEntityListService,
  getAllArea as getAllAreaService,
  getEntityDetail as getEntityDetailService,
  addEntity as addEntityService,
  removeEntity as removeEntityService,
  updateEntity as updateEntityService,
  getAllResources as getAllResourcesService,
  getEntityDefaultResources as getEntityDefaultResourcesService,
  updateEntityResourceName as updateEntityResourceNameService,
  updateEntityRegisterCount as updateEntityRegisterCountService,
} from '../service/authManage'

export function* getRoleList(payload: Payload) {
  const data: ResponseData = yield call(getRoleListService, payload)
  if (data && data.code === 0) {
    yield put({
      type: AUTHMANAGE.UPDATE_STATE,
      payload: { roleList: data.data },
    })
  }
}

export function* getRoleInfo(payload: Payload) {
  const data: ResponseData = yield call(getRoleInfoService, payload)
  if (data && data.code === 0) {
    yield put({
      type: AUTHMANAGE.UPDATE_STATE,
      payload: { roleInfo: data.data },
    })
  }
}

export function* addRole(payload: Payload) {
  const data: ResponseData = yield call(addRoleService, payload)
  if (data && data.code === 0) {
    message.success('添加成功')
    yield put({
      type: AUTHMANAGE.GET_ROLE_LIST,
    })
    payload.cb && payload.cb()
  }
}

export function* updateRole(payload: Payload) {
  const data: ResponseData = yield call(updateRoleService, payload)
  if (data && data.code === 0) {
    message.success('更新成功')
    yield put({
      type: AUTHMANAGE.GET_ROLE_LIST,
    })
    payload.cb && payload.cb()
  }
}

export function* updateRoleResourceBind(payload: Payload) {
  const data: ResponseData = yield call(updateRoleResourceBindService, payload)
  if (data && data.code === 0) {
    message.success('更新成功')
    yield put({
      type: AUTHMANAGE.GET_ROLE_INFO,
      payload: {
        id: payload.payload?.id,
      },
    })
    payload.cb && payload.cb()
  }
}

export function* getEntityList(payload: Payload) {
  const data: ResponseData = yield call(getEntityListService, payload)
  if (data && data.code === 0) {
    yield put({
      type: AUTHMANAGE.UPDATE_STATE,
      payload: { entityList: data.data },
    })
  }
}

export function* getAllArea(payload: Payload) {
  const data: ResponseData = yield call(getAllAreaService, payload)
  if (data && data.code === 0) {
    yield put({
      type: AUTHMANAGE.UPDATE_STATE,
      payload: { allArea: data.data },
    })
  }
}

export function* getEntityDetail(payload: Payload) {
  const data: ResponseData = yield call(getEntityDetailService, payload)
  if (data && data.code === 0) {
    yield put({
      type: AUTHMANAGE.UPDATE_STATE,
      payload: { entityDetail: data.data },
    })
  }
}

export function* updateEntity(payload: Payload) {
  const data: ResponseData = yield call(updateEntityService, payload)
  if (data && data.code === 0) {
    message.success('更新成功')
    yield put({
      type: AUTHMANAGE.GET_ENTITY_DETAIL,
      payload: { id: payload.payload?.id },
    })
    yield put({
      type: AUTHMANAGE.GET_ENTITY_LIST,
    })
    payload.cb && payload.cb()
  } else {
    payload.errCb && payload.errCb()
  }
}

export function* addEntity(payload: Payload) {
  const data: ResponseData = yield call(addEntityService, payload, { loadingName: 'ADDENTITY' })
  if (data && data.code === 0) {
    message.success('添加成功')
    yield put({
      type: AUTHMANAGE.GET_ENTITY_LIST,
    })
    payload.cb && payload.cb()
  }
}

export function* removeEntity(payload: Payload) {
  const data: ResponseData = yield call(removeEntityService, payload)
  if (data && data.code === 0) {
    message.success('删除成功')
    yield put({
      type: AUTHMANAGE.GET_ENTITY_LIST,
    })
    payload.cb && payload.cb()
  }
}

export function* updateEntityResourceName(payload: Payload) {
  const data: ResponseData = yield call(updateEntityResourceNameService, payload)
  if (data && data.code === 0) {
    message.success('更新成功')
    yield put({
      type: AUTHMANAGE.GET_ENTITY_DETAIL,
      payload: { id: payload.payload?.entityId },
    })
    payload.cb && payload.cb()
  }
}

export function* getAllResources(payload: Payload) {
  const data: ResponseData = yield call(getAllResourcesService, payload)
  if (data && data.code === 0) {
    yield put({
      type: AUTHMANAGE.UPDATE_STATE,
      payload: { allResources: data.data },
    })
    payload.cb && payload.cb()
  }
}

export function* getEntityDefaultResources(payload: Payload) {
  const data: ResponseData = yield call(getEntityDefaultResourcesService, payload)
  if (data && data.code === 0) {
    yield put({
      type: AUTHMANAGE.UPDATE_STATE,
      payload: { entityDefaultResources: data.data },
    })
    payload.cb && payload.cb()
  }
}

export function* updateEntityRegisterCount(payload: Payload) {
  const data: ResponseData = yield call(updateEntityRegisterCountService, payload)
  if (data && data.code === 0) {
    message.success('更新成功')
    yield put({
      type: AUTHMANAGE.GET_ENTITY_DETAIL,
      payload: { id: payload.payload?.id },
    })
    payload.cb && payload.cb()
  }
}

export default function* root() {
  yield takeEvery(AUTHMANAGE.GET_ROLE_LIST, getRoleList)
  yield takeEvery(AUTHMANAGE.GET_ROLE_INFO, getRoleInfo)
  yield takeEvery(AUTHMANAGE.ADD_ROLE, addRole)
  yield takeEvery(AUTHMANAGE.UPDATE_ROLE, updateRole)
  yield takeEvery(AUTHMANAGE.UPDATE_ROLE_RESOURCE_BIND, updateRoleResourceBind)
  yield takeEvery(AUTHMANAGE.GET_ENTITY_LIST, getEntityList)
  yield takeEvery(AUTHMANAGE.GET_ALL_AREA, getAllArea)
  yield takeEvery(AUTHMANAGE.GET_ENTITY_DETAIL, getEntityDetail)
  yield takeEvery(AUTHMANAGE.ADD_ENTITY, addEntity)
  yield takeEvery(AUTHMANAGE.REMOVE_ENTITY, removeEntity)
  yield takeEvery(AUTHMANAGE.UPDATE_ENTITY, updateEntity)
  yield takeEvery(AUTHMANAGE.GET_ALL_RESOURCES, getAllResources)
  yield takeEvery(AUTHMANAGE.GET_ENTITY_DEFAULT_RESOURCES, getEntityDefaultResources)
  yield takeEvery(AUTHMANAGE.UPDATE_ENTITY_RESOURCE_NAME, updateEntityResourceName)
  yield takeEvery(AUTHMANAGE.UPDATE_ENTITY_REGISTER_COUNT, updateEntityRegisterCount)
}
